import axiosAgsc from "@/store/axiosAgsc";
const resource = "/Group";

export default {
  get: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetGroups`, payload);
  },
  getById: (groupId: any = {}): any => {
    if(Object.keys(groupId).length === 0) {
      return false;
    }
    return axiosAgsc.get(`${resource}/GetGroupById`, {
      params: { groupId },
    });
  },
  getSiteGroups: (siteGuid: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetSiteGroups`, {
      params: { siteGuid },
    });
  },
  getGroupVersions: (groupGuid: any = {}): any => {
    return axiosAgsc.get(`/Event/GetEventsPolicyFileVersionByGroupGuid?groupGuid=${groupGuid}`, {
      params: { groupGuid },
    });
  },
};
